export const translate = (key: string) =>
  (global['LitiumTexts'] && global['LitiumTexts'][key]) || key;
